document.querySelectorAll( '.b-anchors-navigation' ).forEach( ( nav ) => {

	const links = [ ...nav.querySelectorAll( '.b-anchor-link' ) ];

	if ( !links.length ) {

		return;

	}

	const configuredLabel = nav.dataset.label?.trim();
	const fallbackLabelFromContent = nav.querySelector(
		'.b-anchors-navigation__label-text, .b-anchors-navigation__label',
	)?.textContent?.trim();
	const defaultLabel = configuredLabel || fallbackLabelFromContent || 'On this page';

	// Ensure dropdown toggle exists in DOM (handles old saved markup without it).
	let dropdownToggle = nav.querySelector(
		'.b-anchors-navigation__dropdown-toggle',
	);

	if ( !dropdownToggle ) {

		const { templateUrl } = window.wombat?.settings ?? {};
		const chevronSrc = templateUrl
			? `${ templateUrl }/src/images/button-icons/chevron-down.svg`
			: '';

		dropdownToggle = document.createElement( 'button' );
		dropdownToggle.type = 'button';
		dropdownToggle.className = 'b-anchors-navigation__dropdown-toggle';
		dropdownToggle.setAttribute( 'aria-expanded', 'false' );

		const generatedLabel = document.createElement( 'span' );
		generatedLabel.className = 'b-anchors-navigation__dropdown-label';
		generatedLabel.textContent = defaultLabel;
		dropdownToggle.append( generatedLabel );

		if ( chevronSrc ) {

			const generatedIcon = document.createElement( 'img' );
			generatedIcon.src = chevronSrc;
			generatedIcon.className = 'b-anchors-navigation__dropdown-icon';
			generatedIcon.alt = '';
			generatedIcon.setAttribute( 'aria-hidden', 'true' );
			generatedIcon.width = 24;
			generatedIcon.height = 24;
			dropdownToggle.append( generatedIcon );

		}

		const wrapper = nav.querySelector( '.b-anchors-navigation__wrapper' );
		( wrapper ?? nav ).prepend( dropdownToggle );

	}

	let outsideClickListener;

	/**
	 * Close dropdown and remove active outside-click listener.
	 */
	const closeDropdown = () => {

		nav.classList.remove( 'is-open' );
		dropdownToggle.setAttribute( 'aria-expanded', 'false' );

		if ( outsideClickListener ) {

			outsideClickListener.abort();
			outsideClickListener = null;

		}

	};

	// Add click listener to toggle dropdown open/closed.
	dropdownToggle.addEventListener( 'click', () => {

		const isOpen = nav.classList.toggle( 'is-open' );
		dropdownToggle.setAttribute( 'aria-expanded', String( isOpen ) );

		if ( isOpen ) {

			// Remove any existing outside-click listener before adding a new one.
			outsideClickListener = new AbortController();

			// Add click listener to close dropdown when clicking outside of it.
			document.addEventListener( 'click', ( e ) => {

				if ( !nav.contains( e.target ) ) {

					closeDropdown();

				}

			}, { signal: outsideClickListener.signal } );

		} else {

			closeDropdown();

		}

	} );

	links.forEach( ( link ) => {

		link.addEventListener( 'click', () => {

			closeDropdown();

		} );

	} );

	nav.addEventListener( 'focusout', ( e ) => {

		if ( !nav.contains( e.relatedTarget ) ) {

			closeDropdown();

		}

	} );

} );
